export default __webpack_public_path__ + "static/media/IMG-20241210-WA0019.7f73c577.jpg";